<template>
  <div class="my-tab">
    <div class="list">
      <div class="list-one" v-for="(item, index) in QuickList" @click="linkTo(item)" :key="index">
        <img :src="item.Icon" class="iconImg" />
        <span>{{ item.Name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "navTab",
  props: {
    QuickList: {
      type: Array,
      default: function() {
        return [
          {
            Icon: "https://img.zhanshangxiu.com/showonline/file/202507/20250709/153177aa34ed415cabed56b3a12842cb.png",
            Id: "50352a21-d279-46af-88fa-3520f50f2dc1",
            ItemId: "abebd606-efd5-41a0-9858-7fbaca72692f",
            Link: "https://m.zhanshangxiu.com/headlines/3b3c9c7b-716b-47b9-80e3-a87b84d9273a?type=0",
            Name: "展会概况",
            ShowIndex: "1",
          },
          {
            Icon: "https://img.zhanshangxiu.com/showonline/file/202507/20250709/f92876d2edcb4c89817a34d0b40af98e.png",
            Id: "b863f0e3-e3a5-47a7-9bd6-dd596115908e",
            ItemId: "abebd606-efd5-41a0-9858-7fbaca72692f",
            Link: "https://m.zhanshangxiu.com/headlines/3b3c9c7b-716b-47b9-80e3-a87b84d9273a?type=1",
            Name: "供需发布",
            ShowIndex: "2",
          },
          {
            Icon: "https://img.zhanshangxiu.com/showonline/file/202507/20250709/1b41a378c5c944718dee28e4c917f35f.png",
            Id: "c08120a1-1f12-4b18-b1ea-52cc22fe102c",
            ItemId: "abebd606-efd5-41a0-9858-7fbaca72692f",
            Link: "https://m.zhanshangxiu.com/default/3b3c9c7b-716b-47b9-80e3-a87b84d9273a?type=0",
            Name: "展位预览",
            ShowIndex: "3",
          },
          {
            Icon: "https://img.zhanshangxiu.com/showonline/file/202507/20250709/0fb90f5a68244560ac6dfc129b22c997.png",
            Id: "9f19cabf-5055-42ca-8785-87de7226a196",
            ItemId: "abebd606-efd5-41a0-9858-7fbaca72692f",
            Link: "https://m.zhanshangxiu.com/custom-form",
            Name: "注册参观",
            ShowIndex: "4",
          },
        ];
      },
    },
  },
  data() {
    return {
      onLineQuickList: [],
      HGexhibitionList: [
        "63af2701-17c3-4fb1-b826-aca9228adcc3",
        "3bc3ed3d-d84e-40d6-be92-910905ba0576",
        "5fe797f0-a87e-46a6-ae72-48205eda9086",
        "68da03a5-8127-43b0-903c-97ccb982c429",
        "33ffaaa0-6c0d-4878-b96e-d22573d3b038",
      ],
      isHG: false,
    };
  },
  computed: {
    ...mapGetters({
      exonId: "getExhibitionId",
      exConfig: "getExConfig",
      userInfo: "getUserInfo",
    }),
    exhibitionId() {
      return this.$route.params.id || this.exonId;
    },
  },
  methods: {
    ...mapActions({
      visitToLinkRegister: "register/visitToLinkRegister",
      LinkToHeadLinesTab: "linkTo/LinkToHeadLinesTab",
      LinkToReg: "linkTo/LinkToReg",
      LinkFooter: "linkTo/LinkFooter",
    }),
    linkTo(item) {
      console.log(item);
      //1 展会概况  2 供需商机 3展位预览 4注册参观
      switch (item.ShowIndex) {
        case "1": {
          // this.$store.commit('setHeadTab','exinfo');
          // this.LinkFooter({url:`/news/${this.exhibitionId}`})
          this.LinkToHeadLinesTab(`/headlinesExinfo`);
          break;
        }
        case "2": {
          // this.$store.commit('setHeadTab','needs');
          // this.LinkFooter({url:`/news/${this.exhibitionId}`})
          this.LinkToHeadLinesTab(`/headlinesNeeds`);
          break;
        }
        case "3": {
          let opt = {
            url: `/boothView/${this.exhibitionId}`,
          };
          this.LinkFooter(opt);
          // this.$toast('暂未开放，敬请期待')
          break;
        }
        case "4": {
          if (this.exhibitionId == "63af2701-17c3-4fb1-b826-aca9228adcc3") {
            window.open("http://xzt.eastfair.com/EztEnV1/index.html#/home?ExhID=1013&InviteType=Platform&InviteID=0&InviteCode=FShow");
            return;
          }
          this.HGexhibitionList.forEach((c) => {
            if (c.indexOf(this.exhibitionId) != -1) {
              this.isHG = true;
              window.open("http://xzt.eastfair.com/EztEnV1/index.html#/home?ExhID=1013");
            }
          });

          if (this.userInfo.inMember.userRole.toUpperCase() != "VISITOR" && !this.isHG) {
            this.$toast("You have already registered");
            return;
          } else {
            this.LinkToReg();
          }
          break;
        }
        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
.my-tab {
  background-color: #fff;
  margin-bottom: 15px;
  padding-bottom: 14px;
}
.list {
  display: flex;
  flex-wrap: wrap;
}
.list-one {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-top: 14px;
  width: 25%;
}
.iconImg {
  width: 42px;
  height: 42px;
  display: block;
}
.iconfont {
  text-align: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  font-size: 30px;
  line-height: 42px;
  color: #fff;
}
.list-one span {
  font-size: 0.22rem;
  color: #333;
  margin-top: 4px;
}
.s0 {
  background-image: linear-gradient(0deg, #22d9bb 0%, #3bf2d1 100%), linear-gradient(#ff7439, #ff7439);
}
.s1 {
  background-image: linear-gradient(0deg, #4678ff 0%, #9cb2ff 100%), linear-gradient(#ff7439, #ff7439);
}
.s2 {
  background-image: linear-gradient(0deg, #275aff 0%, #3c91ff 100%), linear-gradient(#ff7439, #ff7439);
}
.s3 {
  background-image: linear-gradient(0deg, #ffa01a 0%, #ffbf1f 100%), linear-gradient(#ff7439, #ff7439);
}
.s4 {
  background-image: linear-gradient(0deg, #2a9efe 0%, #74d7ff 100%), linear-gradient(#ff7439, #ff7439);
}
.s5 {
  background-image: linear-gradient(0deg, #fb23fb 0%, #ffa2d6 100%), linear-gradient(#ff7439, #ff7439);
}
.s6 {
  background-image: linear-gradient(0deg, #ff2468 0%, #ff849e 100%), linear-gradient(#ff7439, #ff7439);
}
.s7 {
  background-image: linear-gradient(0deg, #2a9efe 0%, #74d7ff 100%), linear-gradient(#ff7439, #ff7439);
}
.s8 {
  background-image: linear-gradient(0deg, #275aff 0%, #3c91ff 100%), linear-gradient(#ff7439, #ff7439);
}
.s9 {
  background-image: linear-gradient(0deg, #ffa01a 0%, #ffbf1f 100%), linear-gradient(#ff7439, #ff7439);
}
.s10 {
  background-image: linear-gradient(0deg, #2a9efe 0%, #74d7ff 100%), linear-gradient(#ff7439, #ff7439);
}
.s11 {
  background-image: linear-gradient(0deg, #fb23fb 0%, #ffa2d6 100%), linear-gradient(#ff7439, #ff7439);
}
.s12 {
  background-image: linear-gradient(0deg, #4678ff 0%, #9cb2ff 100%), linear-gradient(#ff7439, #ff7439);
}
</style>
